export enum BlockedTypeEnum {
  COMMENT = 'COMMENT',
  CHAT = 'CHAT',
}
